import React, {Component, lazy, Suspense} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {Spinner} from '../spinner';
import Layout from './layout';
import requireAuth from 'feedback-system/auth/requiresAuth';
import {USER_ROLE} from 'feedback-system/modules/user-profile/constants';
import {
    fetchUser
} from 'feedback-system/auth/actions';
import {
    getPeriodsAction
} from './services/actions';
import {OwnProps, State} from './typedef';
import {redirectToLoginPage} from '../../utils';

interface Dispatch {
    getPeriodsAction: typeof getPeriodsAction;
    fetchUser: typeof fetchUser;
}

type IProps = OwnProps & Dispatch;

const QualityFeedback = lazy(() => import('../quality-feedback'));
const UserProfile = lazy(() => import('../user-profile'));
const NotFound = lazy(() => import('../not-found'));

const FeedbackConsolidationLazy = lazy(() => import('../feedback-consolidation'));
const FeedbackOverviewLazy = lazy(() => import('../feedback-overview'));
const EmployeesLazy = lazy(() => import('../employees'));
const AdminLazy = lazy(() => import('../admin'));

const FeedbackConsolidation = requireAuth(FeedbackConsolidationLazy,
    [USER_ROLE.MANAGER]
);
const FeedbackOverview = requireAuth(FeedbackOverviewLazy,
    [USER_ROLE.MANAGER, USER_ROLE.SENIOR_LEAD, USER_ROLE.ASSOCIATED_TL,
        USER_ROLE.BOARD, USER_ROLE.TL, USER_ROLE.PM]);
const Employees = requireAuth(EmployeesLazy,
    [USER_ROLE.USER]);
const Admin = requireAuth(AdminLazy, [USER_ROLE.ADMIN]);

class MainContainer extends Component<IProps, State> {

    componentDidMount() {
        const data = localStorage.getItem('accessToken');
        if (!data) {
            redirectToLoginPage();
        } else {
            this.props.fetchUser();
            this.props.getPeriodsAction();
        }
    }

    render() {
        return (
            <Layout>
                {this.props.auth && this.props.periods && this.props.currentPeriod && this.props.calendarPeriod ?
                    <Suspense fallback={<Spinner/>}>
                        <Switch>
                            <Route path="/" component={QualityFeedback} exact={true}/>
                            <Route path="/feedback-consolidation" component={FeedbackConsolidation}/>
                            <Route path="/feedback-overview" component={FeedbackOverview}/>
                            <Route path="/employees" component={Employees}/>
                            <Route path="/admin" component={Admin}/>
                            <Route path="/profile" component={UserProfile}/>
                            <Route component={NotFound}/>
                        </Switch>
                    </Suspense> : <Spinner/>}
            </Layout>
        );
    }
}

const mapDispatchToProps: Dispatch = {
    getPeriodsAction,
    fetchUser
};

const mapStateToProps = (state: any) => ({
    periods: state.periods.list,
    currentPeriod: state.periods.current,
    calendarPeriod: state.periods.calendar,
    auth: state.authenticated
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(MainContainer);
